import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { memo, useCallback, useMemo, useState } from "react";
import MainApi from "../../../../../../services/mainApi.service";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { Table } from "@4uhub/lib4uhub";
import { useAutomationRules } from "../../../../../../store/contexts/AutomationRulesContext";
import { ITicketAutomationMsgTicketAutTemplate } from "../../../../../../models/automation-message-ticket-automation-template";
import { AutomationTemplate } from "./AutomationTemplateForm/AutomationTemplate";

const TICKET_AUTOMATION_MESSAGES_TICKET_DEFAUL_DOC_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationMsgTicketAutTemplate/";
const ticketAutomationService =
  new MainApi<ITicketAutomationMsgTicketAutTemplate>(
    TICKET_AUTOMATION_MESSAGES_TICKET_DEFAUL_DOC_ROUTE,
  );

const translationPath =
  "chatBot.page.automations.ticketAutomationMsgTicketAutTemplate.";

export const AutomationTemplatePage = memo(() => {
  const [timeRuleForm, setTimeRuleForm] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const { t } = useTranslation();

  const { id } = useParams();

  const { automation } = useAutomationRules();

  const columns: GridColDef<ITicketAutomationMsgTicketAutTemplate>[] = [
    {
      field: "sendWhen",
      maxWidth: 150,
      headerName: t(translationPath + "send_when") || "Automation Message Type",
      renderCell: (params) => params.row.sendWhen.name,
    },
    {
      field: "ticketAutomationTemplate",
      headerName:
        t(translationPath + "ticket_automation_template") ||
        "TicketAutomationTemplate",
      renderCell: (params) => params.row.ticketAutomationTemplate.name,
    },
  ];
  if (automation && automation.code !== "7") {
    columns.push({
      field: "schedules",
      headerName: t(translationPath + "schedules") || "schedules",
    });
    columns.push({
      field: "insurances",
      headerName: t(translationPath + "insurances") || "insurances",
    });
  }
  const handleAdd = () => {
    setTimeRuleForm(true);
  };

  const handleRowClick = (
    params: GridRowParams<ITicketAutomationMsgTicketAutTemplate>,
  ) => {
    if (!params.row) return;
    setTimeRuleForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setTimeRuleForm(false);
  }, []);

  const props = useMemo(() => {
    return {
      TicketAutomationRuleId: id,
    };
  }, [id]);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {timeRuleForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <AutomationTemplate
            id={selectedId}
            ticketAutomationRuleId={id}
            onBackButton={handleBack}
          />
        </Box>
      )}
      {!timeRuleForm && (
        <Box height={600}>
          <Table<ITicketAutomationMsgTicketAutTemplate>
            showDefaultMacroFilters={false}
            service={ticketAutomationService}
            columns={columns}
            title={""}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputAutoFocus={false}
            defaultPageSize={20}
            serviceProps={props}
            pageSizeOptions={[5, 10, 20]}
            searchInputPlaceHolder={""}
            addButtonLabel={
              t(translationPath + "add") || "Add Automation Message"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
});
